<!-- 带计数的tabs标签页 -->
<template lang="pug">
    div.count-tabs
        el-tabs(
            v-model="activeName"
            @tab-click="tabClickHandle"
            v-if="!isDetail"
        )
            el-tab-pane(
                v-for="(item, index) in options"
                :key="index"
                :name="item.name"
            )
                div(slot="label")
                    span.label {{ item.label }}
                    span.count(v-if="showCount") {{ item.count }}
                    slot(:name="`tabPaneSlot${index}`")
        el-tabs.detail-tab(
            v-model="activeName"
            @tab-click="tabClickHandle"
            v-else
        )
            el-tab-pane(
                v-for="(item, index) in options"
                :key="index"
                :name="item.name"
            )
                div(slot="label")
                    span.label {{ item.label }}
                    span.count(v-if="detailCount && item.count !== null") {{ item.count }}
        div.right-slot
            slot
</template>
<script>
export default {
    name: 'CountTabs',
    props: {
        value: {
            type: String,
            default: '',
        },
        /**
             * tabs配置项
             * @example
             *           [
             *               {
             *                   label: '用户管理',
             *                   name: 'first',
             *                   count: 0,
             *               },
             *           ]
             */
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        // 是否显示计数，默认显示
        showCount: {
            type: Boolean,
            default: true,
        },
        // 是否是详情使用
        isDetail: {
            type: Boolean,
            default: false,
        },
        detailCount: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        // 选中选项卡的 name
        activeName: {
            set(val) {
                this.$emit('input', val);
            },
            get() {
                return this.value;
            },
        },
    },
    methods: {
        tabClickHandle(tab) {
            this.$emit('tab-click', tab);
        },
    },
};
</script>
<style lang="scss" scoped>
    .count-tabs {
        position: relative;
        height: 50px;
    }
    .right-slot {
        position: absolute;
        top: 0;
        right: 0;
        height: 50px;
        padding-right: 20px;
        line-height: 50px;
        @include font_size(text_form_title);
        @include font_color(text_color_primary);
    }
</style>
<style lang="scss">
    .count-tabs {
        .el-tabs__item {
            font-weight: normal;
        }
        .detail-tab .el-tabs__nav-wrap::after {
            height: 0;
        }
    }
</style>
